import { HttpClient, ListParams } from './http-client';
import Paginate from '../interfaces/paginate';
import GroupAnimal from '../interfaces/group-animal';
import GroupAnimalPigs from '../interfaces/group-animal-pigs';
import { Observable } from 'rxjs';
import GroupAnimalNotes from '../interfaces/group-animal-note';

interface Option {
  label: string;
  value: string;
}

export class GroupAnimalService extends HttpClient {
  sync(farmId: string, params?: ListParams): Observable<void> {
    return this.post<void>(
      `/api/farms/${farmId}/livestock/animal-group/sync`,
      params
    );
  }

  index(
    farmId: string,
    params?: ListParams,
    getAll?: boolean
  ): Observable<Paginate<GroupAnimal | GroupAnimalPigs>> {
    return this.get<Paginate<GroupAnimal | GroupAnimalPigs>>(
      `/api/farms/${farmId}/livestock/animal-group`,
      { ...params, getAll }
    );
  }

  species(farmId: string, urlParams) {
    return this.get<Option[]>(
      `/api/farms/${farmId}/livestock/animal-group/species-filter-values`,
      urlParams
    );
  }

  showTab(farmId: string) {
    return this.get<{ show: boolean }>(
      `/api/farms/${farmId}/livestock/animal-group/show-tab`
    );
  }
  notes(farmId: string, groupAnimalId: string, apiRoutePrefix) {
    return this.get<GroupAnimalNotes[]>(
      `/api/farms/${farmId}/livestock/animal-group${apiRoutePrefix}/${groupAnimalId}/notes`
    );
  }

  storeNote(
    farmId: string,
    groupAnimalId: string,
    note: GroupAnimalNotes,
    apiRoutePrefix
  ) {
    return this.post<GroupAnimalNotes>(
      `/api/farms/${farmId}/livestock/animal-group${apiRoutePrefix}/${groupAnimalId}/note`,
      note
    );
  }

  updateNote(
    farmId: string,
    groupAnimalId: string,
    noteId: string,
    note: GroupAnimalNotes,
    apiRoutePrefix: string
  ) {
    return this.put<GroupAnimalNotes>(
      `/api/farms/${farmId}/livestock/animal-group${apiRoutePrefix}/${groupAnimalId}/note/${noteId}`,
      note
    );
  }

  deleteNote(
    farmId: string,
    groupAnimalId: string,
    noteId: string,
    apiRoutePrefix: string
  ) {
    return this.delete<void>(
      `/api/farms/${farmId}/livestock/animal-group${apiRoutePrefix}/${groupAnimalId}/note/${noteId}`
    );
  }
  barns(farmId: string, urlParams): Observable<Option[]> {
    return this.get<Option[]>(
      `/api/farms/${farmId}/livestock/animal-group/barn-filter-values`,
      urlParams
    );
  }

  exportXls(farmId: string, params?: ListParams): Observable<object> {
    return this.export(`/api/farms/${farmId}/livestock/animal-group`, params);
  }
}
